import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import InfoTooltip from '../../common/InfoTooltip';
import AdjustPositionDropdown from '../AdjustPositionDropdown';
import { useImage } from '../../../context/ImageContext';
 
const AdvancedSettings = ({ 
  advancedSettingsOpen, 
  setAdvancedSettingsOpen, 
  backdropOnly, 
  setBackdropOnly, 
  reLight, 
  setReLight,
  containerRef,
  imageRef,
  mySelectedImage,
  adjustDropdownIsOpen,
  setAdjustDropdownIsOpen,
  aspectRatio
}) => {
  const { selectedImage } = useImage();

  useEffect(() => {
    if (reLight || backdropOnly) {
      setAdjustDropdownIsOpen(selectedImage.alt !== 'No Product Selected');
    }else{
      setAdjustDropdownIsOpen(false);
    }
  }, [reLight, backdropOnly, selectedImage]);

  return (
    <div className="bg-white rounded-2xl pt-2 pb-1 transition-all duration-300">
      {/* Header */}
      <button
        className="flex items-center w-full mb-1 focus:outline-none hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors duration-200"
        onClick={() => setAdvancedSettingsOpen(v => !v)}
        type="button"
        aria-label="Toggle Advanced Settings"
      >
        <span className="text-black-800 text-sm flex-1 text-left">Advanced Settings</span>                  
        <FontAwesomeIcon
          icon={advancedSettingsOpen ? faChevronDown : faChevronRight}
          className="text-gray-400 ml-2 flex-shrink-0 transition-transform duration-300 pr-2"
        />
      </button>
      {advancedSettingsOpen && (
        <div className="space-y-4 px-2 pb-2 pt-1">
          {/* Toggle Controls Row */}
          <div className="flex flex-row items-center justify-between gap-3 pr-2">           
            {/* Re-Light Toggle */}
            <div className="flex items-center gap-1">
              <button
                type="button"
                aria-label="Re-Light"
                onClick={() => {
                  if (!reLight) {
                    setReLight(true);
                    setBackdropOnly(false);
                  } else {
                    setReLight(false);
                  }
                }}
                className={`w-7 h-4 sm:w-8 sm:h-5 md:w-10 md:h-6 rounded-full transition-colors duration-200 flex items-center ${reLight ? 'bg-purple-600 justify-end' : 'bg-gray-300 justify-start'}`}
                tabIndex={0}
                role="switch"
                aria-checked={reLight}
              >
                <span className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 bg-white rounded-full shadow transition-all duration-200"></span>
              </button>
              <span className="text-sm text-gray-700 ml-0.5">Re-Light</span>
              <InfoTooltip iconSize={12} >
                Automatically adjusts the lighting on your product to match the scene, while keeping its angle and size unchanged. This helps blend the product naturally with the generated environment.
              </InfoTooltip>
            </div>
             {/* Backdrop Only Toggle */}
             <div className="flex items-center gap-1">
              <button
                type="button"
                aria-label="Backdrop Only"
                onClick={() => {
                  if (!backdropOnly) {
                    setBackdropOnly(true);
                    setReLight(false);
                  } else {
                    setBackdropOnly(false);
                  }
                }}
                className={`w-7 h-4 sm:w-8 sm:h-5 md:w-10 md:h-6 rounded-full transition-colors duration-200 flex items-center ${backdropOnly ? 'bg-purple-600 justify-end' : 'bg-gray-300 justify-start'}`}
                tabIndex={0}
                role="switch"
                aria-checked={backdropOnly}
              >
                <span className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 bg-white rounded-full shadow transition-all duration-200"></span>
              </button>
              <span className="text-sm text-gray-700 ml-0.5">Backdrop Only</span>
              <InfoTooltip iconSize={12}>
                Generates a background around your product without changing its angle, size, lighting, or placement.
                Tip: Make sure your prompt matches the lighting already present on the product for the best results.
              </InfoTooltip>
            </div>
          </div>

          {/* Adjust Position Dropdown */}
          <div>
            <AdjustPositionDropdown
              containerRef={containerRef}
              imageRef={imageRef}
              mySelectedImage={mySelectedImage}
              isOpen={adjustDropdownIsOpen}
              setIsOpen={setAdjustDropdownIsOpen}
              aspectRatio={aspectRatio}
              setReLight={setReLight}
              setBackdropOnly={setBackdropOnly}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvancedSettings; 